import { Link, usePage } from "@inertiajs/react"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { InlineInput } from "@/components/ui/inline-input"
import { Label } from "@/components/ui/label"
import { t } from "@/lib/i18n"
import { putInline } from "@/lib/inline-update"
type Table = {
    id: number
    externalId: string
    name: string
    seats: number
}
export default function StaffLocationManageTablesEdit() {
    const { table } = usePage<{ table: Table }>().props
    const updateTable = (data: Record<string, string>) => putInline(`/manage/tables/${table.externalId}`, data)
    return (<StaffLayout>
      <MainContainer size="sm">
        <PageHeader title={t("ui.react.pages.staff.location.manage.tables.edit.edit_table")} description={t("ui.react.pages.staff.location.manage.tables.edit.update_configuration_table")} actions={<Button asChild variant="outline" size="sm">
            <Link href="/manage/tables">{t("ui.react.pages.staff.location.manage.tables.edit.back_tables")}</Link>
          </Button>}/>

        <Card data-testid="table-form-card">
          <CardContent>
            <div className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="name">{t("ui.react.pages.staff.location.manage.tables.edit.name")}</Label>
                <InlineInput id="name" data-testid="table-name-input" value={table.name} placeholder={t("ui.react.pages.staff.location.manage.tables.edit.table")} onSubmit={(value) => updateTable({ name: value })}/>
              </div>

              <div className="space-y-2">
                <Label htmlFor="seats">{t("ui.react.pages.staff.location.manage.tables.edit.seats")}</Label>
                <InlineInput id="seats" data-testid="table-seats-input" type="number" min="1" step="1" value={String(table.seats)} onSubmit={(value) => updateTable({ seats: value })}/>
              </div>
            </div>
          </CardContent>
        </Card>
      </MainContainer>
    </StaffLayout>)
}
